import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PageUrls } from 'src/app/helpers/page-urls';
import { AppUtils } from 'src/app/helpers/app.utils';
import { UserService } from 'src/app/admin/services/user.service';
import { TableModel } from 'src/app/models/table.model';
import { Router } from '@angular/router';
import { PagedChiefEditorDetailModel } from 'src/app/admin/models/paged.chief-editor.detail.model';

@Component({
    selector: 'app-user-chief-editor',
    templateUrl: './user.chief-editor.component.html',
    styleUrls: ['./user.chief-editor.component.scss']
})
export class UserChiefEditorComponent implements OnInit {

    tableModel = new TableModel();
    totalRecords = 1;
    subscriptions = new Array<Subscription>();
    pagedChiefEditorDetail = new PagedChiefEditorDetailModel();
    isModelLoaded = false;

    constructor(private router: Router, private ngxSpinner: NgxSpinnerService,
        private toastr: ToastrService,
        private userService: UserService) {
        this.tableModel.orderBy = 'FirstName';
        this.tableModel.orderByDirection = 'asc';
    }

    get urls() {
        return PageUrls;
    }

    ngOnInit() {
        this.initSubscribers();
        this.getChiefEditors();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getChiefEditors());
        this.subscriptions.push(subscription);
    }

    getChiefEditors() {
        this.isModelLoaded = false;
        this.ngxSpinner.show();
        this.userService.listChiefEditor(this.tableModel)
            .subscribe(data => {
                this.pagedChiefEditorDetail = data;
                this.totalRecords = data.totalCount;
                this.ngxSpinner.hide();
                this.isModelLoaded = true;
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    deleteChiefEditor(id: number) {
        if (!confirm('Are you sure you want to delete this chief-editor?')) {
            return;
        }
        this.ngxSpinner.show();
        this.userService.deleteChiefEditor(id)
            .subscribe(() => {
                this.toastr.success('Chief-Editor has been deleted successfully');
                this.ngxSpinner.hide();
                this.getChiefEditors();
            }, error => {
                this.ngxSpinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }

    openEditChiefEditor(id: number) {
        this.router.navigateByUrl(`${PageUrls.Admin.UserEditChiefEditor}?chiefEditorId=${id}`);
    }

    resetTableModel() {
        this.tableModel.page = 1;
    }
}
